import React from 'react'

export default function NotFoundPage() {
    return (
        <div>
            <img src="https://seo-trench.com/wp-content/uploads/2019/08/Page-Erreurs-404-votre-site-web-et-Google.jpg" alt="Sorry page not found"/>
        </div>
    )
}
